// extracted by mini-css-extract-plugin
var _1 = "RentalPortalViewingProfileTabs-moduleskeleton__vBThY Skeleton-moduleSkeleton__Mlrfv";
var _2 = "RentalPortalViewingProfileTabs-moduletabsWrapper__CeBw6";
export { _1 as "skeleton", _2 as "tabsWrapper" }
